<!--
  @component
  A menu item widget with a checkbox.
  @see https://w3c.github.io/aria/#menuitemcheckbox
-->
<script>
  import Icon from '../icon/icon.svelte';
  import MenuItem from './menu-item.svelte';

  /**
   * @import { ButtonProps, CommonEventHandlers, MenuItemProps } from '../../typedefs';
   */

  /**
   * @type {ButtonProps & MenuItemProps & CommonEventHandlers & Record<string, any>}
   */
  let {
    /* eslint-disable prefer-const */
    checked = $bindable(),
    class: className,
    hidden = false,
    disabled = false,
    label = '',
    children: _children,
    startIcon: _startIcon,
    onChange,
    ...restProps
    /* eslint-enable prefer-const */
  } = $props();
</script>

<MenuItem
  {...restProps}
  role="menuitemcheckbox"
  class="sui menu-item-checkbox {className}"
  {label}
  {hidden}
  {disabled}
  aria-checked={checked}
  onChange={(event) => {
    onChange?.(event);
    checked = event.detail.checked;
  }}
>
  {#snippet startIcon()}
    {@render _startIcon?.()}
  {/snippet}
  <!-- eslint-disable-next-line svelte/no-useless-children-snippet -->
  {#snippet children()}
    {@render _children?.()}
  {/snippet}
  {#snippet endIcon()}
    {#if checked}
      <Icon name="check" />
    {/if}
  {/snippet}
</MenuItem>
